import type { FC } from 'react'

import { browserEnvs } from '@/shared/envs'
import { logError } from '@/shared/utils/error'
import { UiError } from '@/shared/utils/errorClasses'

import { FinnishPrice } from './FinnishPrice/FinnishPrice'
import { NorwegianPrice } from './NorwegianPrice'
import { SwedishPrice } from './SwedishPrice'
import type { PriceProps } from './types'

const PriceNotFound: FC<PriceProps> = () => {
  logError(
    new UiError(
      'Price component not implemented for this country',
      `Country: ${browserEnvs.NEXT_PUBLIC_COUNTRY}`,
    ),
  )

  return null
}

export const Price = (props: PriceProps) => {
  const country = browserEnvs.NEXT_PUBLIC_COUNTRY
  switch (country) {
    case 'FI':
      return <FinnishPrice {...props} />
    case 'SE':
      return <SwedishPrice {...props} />
    case 'NO':
      return <NorwegianPrice {...props} />
    default:
      return <PriceNotFound {...props} />
  }
}
